import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { id: "page" }

import {onBeforeRouteUpdate, RouteLocationNormalizedLoaded, useRoute,} from "vue-router";
import {onMounted, reactive, ref} from "vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogButton from "@/shared/ui/SogButton.vue";
import Address from "@/shared/model/Address";
import copyTo from "@/shared/utils/CopyTo";
import {useNavigationStore} from "@/modules/Navigation/store";
import apiShoppingCart from "@/modules/ShoppingCart/api";
import SogCard from "@/shared/ui/SogCard.vue";
import ShoppingCartItemComponent from "@/modules/ShoppingCart/components/ShoppingCartItemComponent.vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {computed} from "vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import {useAccountStore} from "@/stores/accountStore";
import {storeToRefs} from "pinia";
import {IdType} from "@/shared/model/idType";
import ShoppingCartItem from "@/shared/model/shoppingCartItem";
import apiOrder from "@/modules/Order/api";
import apiInsurance from "@/modules/Insurance/api";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import apiFile from "@/shared/services/apiFile";
import notificationService from "@/shared/services/NotificationService";


export default /*@__PURE__*/_defineComponent({
  __name: 'cashPointComponent',
  setup(__props) {

const _navigationStore = useNavigationStore()


const _amount = ref(0)

const _items = reactive([{
  id: "",
  productType: "",
  product: "",
  count: 0,
  grossPrice: 0,
  amount: 0,
  manufacturer: "",
  item: undefined as ShoppingCartItem | undefined
}])
const _address: Address = reactive(new Address());
const _spinner = useSpinner()
const _shoppingCartStore = useShoppingCartStore();
const _invoiceCircle = ref("");

const _accountStore = useAccountStore();
const {isBranch: _isBranch} = storeToRefs(_accountStore)

const {currentShoppingCart} = storeToRefs(_shoppingCartStore)

async function init(route: RouteLocationNormalizedLoaded) {
  _spinner.hide()
  const sector = route.params.sector as string;
  if (sector === "purchase") {
    await _shoppingCartStore.initPurchase();
  }

  _items.length = 0;
  const t_array = _shoppingCartStore.getItems();
  t_array.forEach(t => _items.push({
    id: t.id,
    productType: t.insuranceTypeName,
    product: t.productDescription,
    count: t.count,
    grossPrice: t.grossPrice,
    amount: t.amount,
    manufacturer: t.manufacturerName,
    item: t
  }))

  _amount.value = _shoppingCartStore.amount();
  copyTo(currentShoppingCart.value.invoicePerson.Address, _address)
}


onMounted(async () => {
  const route = useRoute();
  await init(route);
})


onBeforeRouteUpdate(async (to) => {
  await init(to);
})


async function finished(id?: string,idType?:IdType) {
  notificationService.success("Die Bestellung wurde erfolgreich abgeschlossen.")
  _shoppingCartStore.clear()
  _spinner.hide()

  // IdType.Order ist 0 und damit falsy - eine Wahrheitspruefung auf idType
  // schickt den haeufigsten Fall faelschlich in den Warenkorb.
  if(id && idType !== undefined) {
    await _navigationStore.showObject(idType, id);
  }
  else{
    await _navigationStore.goToShoppingCart();
  }
}

async function finish() {
  _spinner.show()

  try {
    _shoppingCartStore.setInvoiceCircle(_invoiceCircle.value)
    const t_id = await apiShoppingCart.sale(currentShoppingCart.value);
    if (t_id) {
      if (currentShoppingCart.value.saveActivationPerson) {
        try {
          await apiOrganisationStructure.update(
              _accountStore.person?.id ?? "",
              currentShoppingCart.value.activationPerson.Person,
              currentShoppingCart.value.activationPerson.Address
          );
        } catch {
          // Speichern der Adresse darf den Bestellabschluss nicht blockieren
        }
      }
      if (currentShoppingCart.value.activation) {
        const t_order = await apiOrder.orderLoad(t_id);
        if (t_order?.orderItemToInsurances && t_order?.orderItemToInsurances.length > 0) {
          const t_act = await apiInsurance.InsuranceActivate(currentShoppingCart.value.activationPerson.Person, currentShoppingCart.value.activationPerson.Address, t_order.orderItemToInsurances.map(t => t.insuranceId ?? ""), currentShoppingCart.value.activationDuration)
          if (t_act.length > 0) {
            const t_id = await apiInsurance.initPdf(t_act.map(t => t.id ?? ""), true)
            if (t_id) {
              await apiFile.downloadFile(t_id)
              if(_isBranch.value){
                await finished(t_id,IdType.Pdf);
                return;
              }
            }
          }
        }
      }
      if(_isBranch.value){
        await finished(undefined,undefined);
      }
      else
        await finished(t_id,IdType.Order);
    }
  } finally {
    _spinner.hide()
  }

}

const _isInvoiced = computed(() => {
  return currentShoppingCart.value.isInvoiced
})

const _invoiceVisible = computed(() => {
  return currentShoppingCart.value.isSale
})

const _evbVisible = computed(() => {
  return currentShoppingCart.value.activation
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SogCard, null, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, null, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Zusammenfassung Ihrer Bestellung ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardContent, null, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" Bitte überprüfen Sie noch einmal Ihre Bestellung und klicken Sie anschließend auf \"Kostenpflichtig bestellen\", um Ihre Bestellung abzuschließen. ", -1)
          ]))]),
          _: 1
        }),
        _withDirectives(_createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createVNode(SogCard, null, {
              default: _withCtx(() => [
                _createVNode(SogCardTitle, null, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("Rechnungsempfänger", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(SogCardContent, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_address.fullName), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_address.line1), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_address.street) + " " + _toDisplayString(_address.houseNumber) + " " + _toDisplayString(_address.houseNumberAddition), 1),
                    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_address.postalCode) + " " + _toDisplayString(_address.city), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_address.countryName), 1),
                    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _invoiceVisible.value]
        ]),
        _createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createVNode(SogCard, null, {
              default: _withCtx(() => [
                _createVNode(SogCardTitle, null, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("Positionen", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(SogCardContent, null, {
                  default: _withCtx(() => [
                    _createVNode(SogFlexRow, { style: {"justify-content":"flex-start"} }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_items, (item) => {
                          return (_openBlock(), _createBlock(ShoppingCartItemComponent, {
                            key: item,
                            class: "sog-card-without-title",
                            item: item,
                            "is-invoiced": _isInvoiced.value
                          }, null, 8, ["item", "is-invoiced"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createVNode(SogCard, null, {
              default: _withCtx(() => [
                _createVNode(SogCardTitle, null, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("eVb generieren", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(SogCardContent, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(currentShoppingCart).activationPerson.Person.getFullPersonName()), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(currentShoppingCart).activationPerson.Address.street) + " " + _toDisplayString(_unref(currentShoppingCart).activationPerson.Address.houseNumber) + " " + _toDisplayString(_unref(currentShoppingCart).activationPerson.Address.houseNumberAddition), 1),
                    _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(currentShoppingCart).activationPerson.Address.postalCode) + " " + _toDisplayString(_unref(currentShoppingCart).activationPerson.Address.city), 1),
                    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(currentShoppingCart).activationPerson.Address.countryCode), 1),
                    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(currentShoppingCart).activationDuration) + " Tage ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _evbVisible.value]
        ]),
        _withDirectives(_createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(SogForm, null, {
              default: _withCtx(() => [
                _createVNode(SogFormField, null, {
                  default: _withCtx(() => [
                    _createVNode(SogTextBox, {
                      modelValue: _invoiceCircle.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_invoiceCircle).value = $event)),
                      placeholder: "Referenznummer"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, !_unref(_isBranch)]
            ]),
            _withDirectives(_createVNode(SogCard, null, {
              default: _withCtx(() => [
                _createVNode(SogCardTitle, null, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("Gesamtsumme", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(SogCardContent, null, {
                  default: _withCtx(() => [
                    _createVNode(SogDataLabel, {
                      "value-type": _unref(SogDataLabelValueType).Money,
                      value: _amount.value
                    }, null, 8, ["value-type", "value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, _isInvoiced.value]
            ]),
            _createVNode(SogFlexRow, { style: {"justify-content":"end"} }, {
              default: _withCtx(() => [
                _createVNode(SogButton, {
                  "button-style": _unref(SogButtonStyle).Success,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (finish()))
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode(" Kostenpflichtig bestellen ", -1)
                  ]))]),
                  _: 1
                }, 8, ["button-style"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _items.length>0]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})